import { render, staticRenderFns } from "./link-manage.vue?vue&type=template&id=4b0256a0&"
import script from "./link-manage.vue?vue&type=script&lang=js&"
export * from "./link-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports